module.exports = new __parcel__URL__("svi-household--dataset-cover.7a50ad8a.png").toString();